// extracted by mini-css-extract-plugin
module.exports = {"row":"eWp-X","column":"IJc+Y"};